export default __webpack_public_path__ + "static/media/address-list.5c34fc7f.svg";